// 放接口
import request from "./http"; // 使用实例

// 获取首页数据
export function getIndexdata() {
  return request({
    url: "/app/index/appGetHomePage",
    method: "get",
  });
}

// 获取各种顶部的图片信息
// 传：P_INFO：图片类型
// about-us：关于我们
// product-center：产品中心
// Technical-support：技术支持
// news-update：新闻动态
// contact-us：联系我们
// talent-recruitment：人才招聘
export function getBackground(P_INFO) {
  return request({
    url: "/app/index/appGetBackground",
    method: "get",
    params: P_INFO,
  });
}

// 联系我们城市信息列表
export function getCity() {
  return request({
    url: "/app/index/appGetCity",
    method: "get",
  });
}

// 线上报修
// /app/index/appSaveRepairs
// 传：RE_FIRM_NAME：单位名称
// RE_CONTACTS：联系人
// RE_PHONE：联系电话
// RE_EMAIL：邮箱
// RE_MODEL：产品型号
// RE_SERIAL：仪器序号
// RE_TYPE：服务类型1：维修2：校正
// RE_NOTE：说明

export function requestRepairs(params) {
  return request({
    url: "/app/index/appSaveRepairs",
    method: "post",
    params: params,
  });
}

// 在线留言
// /app/index/appSaveLeaveWord
// 传：LW_TITLE：标题
// LW_NAME：姓名
// LW_PHONE：手机号
// LW_EMAIL：邮箱
// LW_FIXED_LINE：固话
// LW_NOTE：说明
export function leaveWord(params) {
  return request({
    url: "/app/index/appSaveLeaveWord",
    method: "post",
    params: params,
  });
}

// 招聘信息
// /app/index/appGetRecruit
// 传：INPUT：输入框
// PULLNUM：当前页，起始值是1
export function getRecruit(params) {
  return request({
    url: "/app/index/appGetRecruit",
    method: "get",
    params: params,
  });
}

// 新增资讯
// /app/index/appGetInformation
// 传：INPUT：输入框
// PULLNUM：当前页，起始值是1
export function getNews(params) {
  return request({
    url: "/app/index/appGetInformation",
    method: "get",
    params: params,
  });
}

// 资讯详情
// /app/index/appGetInformationDetails
// 传：DB_INFORMATION_ID：资讯id
export function getNewsDetail(params) {
  return request({
    url: "/app/index/appGetInformationDetails",
    method: "get",
    params: params,
  });
}

// 产品分类
export function getType() {
  return request({
    url: "/app/index/appGetType",
    method: "get",
  });
}

// 产品列表
// 传：DB_TYPE_ID：分类id
// INPUT：搜索
// PULLNUM：分页，8条
export function getProduct(params) {
  return request({
    url: "/app/index/appGetProduct",
    method: "get",
    params: params,
  });
}

// 产品详情
// 传：DB_PRODUCT_ID：产品id
export function getProductDetails(params) {
  return request({
    url: "/app/index/appGetProductDetails",
    method: "get",
    params: params,
  });
}

// 获取信息的时候分类
// 返回：nation：国家
// product：产品
// profession：行业
export function getTypeList() {
  return request({
    url: "/app/index/appGetTypeList",
    method: "get",
  });
}

// 产品信息获取
// 传：D_NAME：姓名
// D_FRIM：公司
// D_NATION：国家
// D_PHONE：手机号
// D_EMAIL：邮箱
// D_PROFESSION：行业
// D_PRODUCT：产品
// D_HELP：帮助
export function saveDemand(params) {
  return request({
    url: "/app/index/appSaveDemand",
    method: "post",
    params: params,
  });
}

// 隐私政策
// 传参：EX_TYPE
// 传值：service-agreement
export function getSetting(params) {
  return request({
    url: "/app/index/appGetExplain",
    method: "get",
    params: params,
  });
}
